import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { postBulkQrCode } from "../../services/QrCode/postBulkQrCode";

const OrderUnprocessedQrCode = ({
  orderUnprocessedQrCode,
  setOrderUnprocessedQrCode,
  selectedUnprocessedQrCodeItems,
  storeId,
  storeUserId,
  storeCustomerId,
  processTime,
  bookingOrderId,
  sendResponse,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleConfirmPickup = () => {
    // Reset all previous errors

    if (!errorMessage) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        const bulkQrData = {
          qrcodeList: selectedUnprocessedQrCodeItems.map((item) => item.qrcode),
          status: "DELIVERED",
          // remark: 'ready now',
        };
        // Call the service function for creating pickup request
        postBulkQrCode(storeCustomerId, storeId, bookingOrderId, bulkQrData)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                }

                setIsSubmitButtonPressed(false);
                sendResponse({
                  message,
                  status,
                  modalFun: false,
                });
                setErrorMessage("");
                setOrderUnprocessedQrCode(false);
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
    } else {
      setIsSubmitButtonPressed(false);
    }
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    setOrderUnprocessedQrCode(false);
    setErrorMessage("");
  };

  const renderCardItem = () => {
    return selectedUnprocessedQrCodeItems?.map((item, index) => (
      <div>
        <div key={item.id}>
          <div>
            <div className="flex flex-1 flex-row justify-content-between">
              <p className="text-xl font-medium">{item.qrcode}</p>
              <div>
                <Checkbox checked={true} color={"#00A3FF"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={orderUnprocessedQrCode}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!orderUnprocessedQrCode) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4"
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                UnProcessed Tags
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
            <div className="mt-3 mx-6">{renderCardItem()}</div>
            </div>

            <Button
              className="mt-1 mb-3 mx-4 border-round-xl"
              onClick={handleConfirmPickup}
              disabled={isSubmitButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                RETURN
              </p>
            </Button>
            {errorMessage && (
              <div style={{ alignSelf: "center", marginTop: 5 }}>
                <p>{errorMessage}</p>
              </div>
            )}
          </div>
        )}
      ></Dialog>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default OrderUnprocessedQrCode;
